import { useMemo, createContext, useState, useEffect } from 'react';
import Hero from '../../../components/local/events-master-class/components/Hero';
import ContentSection from '../../../components/local/events-master-class/components/ContentSection';
import axios from 'axios';
import { getStrapiURL } from '../../../lib/api';
import moment from 'moment';
import SiteHeader from '@components/shared/SiteHeader';
import { EventContext } from '../index';
const apiBaseUrl = getStrapiURL();
import { genRegisterRandomNumber } from '@utils/functions/throttle';
import OneClickPopup from '@components/shared/widgets/OneClickPopup';

const MasterClass = ({ masterclass = {} }) => {
  const { attributes: masterclassData = {} } = masterclass;
  const { title, startTime, description, endTime, eventDate, slug } = masterclassData;
  const eventStartTime = moment(eventDate + startTime, 'YYYY-MM-DD hh:mm:ss');
  const eventEndTime = moment(eventDate + endTime, 'YYYY-MM-DD hh:mm:ss');
  const titleHighlights = title?.replace(/{{/g, '#{').replace(/}}/g, '}#').split('#');
  const [EventStatus, setEventStatus] = useState(null);

  const registeredCount = useMemo(() => {
    return genRegisterRandomNumber(eventStartTime);
  }, []);

  useEffect(() => {
    return () => sessionStorage.removeItem('sourceType');
  }, []);

  const registerLink = masterclassData?.registerLink;
  const eventId = registerLink?.match(/\d+/g)?.[0];

  const [isLoading, setLoading] = useState(false);
  const [registerWithOneClick, setRegisterWithOneClick] = useState(false);

  return (
    <>
      <SiteHeader
        title={title?.replace(/[{{,}}]/g, '')}
        desc={description}
        url={`/events/master-class/${slug}`}
        image={masterclassData?.eventImage?.data?.attributes?.url}
      />
      <div className="w-full">
        <EventContext.Provider
          value={{
            ...masterclassData,
            aboutProgram: masterclassData.aboutMasterClass,
            isMasterClass: true,
            registeredCount,
            eventStartTime,
            eventEndTime,
            titleHighlights,
            EventStatus,
            setEventStatus,
            eventId,
            setLoading,
            isLoading,
            setRegisterWithOneClick,
            registerWithOneClick,
          }}
        >
          <Hero />
          <ContentSection />
          {/* <OneClickPopup /> */}
        </EventContext.Provider>
      </div>
    </>
  );
};

export default MasterClass;

export async function getServerSideProps({ query, res }) {
  try {
    const {
      data: { data = [] },
    } = await axios.get(
      `${apiBaseUrl}/api/master-classes?populate=instructor.CompanyImage&populate=instructor.DisplayPicture&populate=instructor.pastCompanies.companyImage&populate=pastEvents.eventImage&populate=eventImage&populate=rewardImage&populate=masterClassIsFor&populate=certificate&populate=faq&filters[slug][$eq]=${query.slug}`
    );

    if (!data.length) {
      return {
        notFound: true,
      };
    }
    res.setHeader('Cache-Control', 'public, s-maxage=1800, stale-while-revalidate');

    return {
      props: {
        masterclass: data?.[0] || [],
      },
    };
  } catch (error) {
    console.log(error);
    return {
      notFound: true,
    };
  }
}

// export async function getStaticPaths() {
//   const {
//     data: { data: masterClasses = [] },
//   } = await axios.get(`${apiBaseUrl}/api/master-classes`);

//   const paths = masterClasses
//     ?.filter(({ attributes }) => attributes.slug)
//     ?.map(({ attributes }) => ({
//       params: { slug: attributes.slug },
//     }));

//   // on-demand if the path doesn't exist.
//   return { paths, fallback: 'blocking' };
// }
